import { prodapiAxiosClient } from "./prodApiClient";

const getShippingAddresses = () => {
    return prodapiAxiosClient
    .get('/api/v1/shippingAddress') 
}

const addShippingAddress = (shippingAddress) => {
    return prodapiAxiosClient
    .post('/api/v1/shippingAddress', shippingAddress);
}

const updateShippingAddress = (shippingAddressId, shippingAddress) => {
    return prodapiAxiosClient
    .put(`/api/v1/shippingAddress/${shippingAddressId}`, shippingAddress);
}

const deleteShippingAddress = (shippingAddressId) => {
    return prodapiAxiosClient
    .delete(`/api/v1/shippingAddress/${shippingAddressId}`);
}

const shippingAddressApi = { getShippingAddresses, addShippingAddress, updateShippingAddress, deleteShippingAddress };
export default shippingAddressApi;